/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { SnackbarProvider } from "notistack";
import { useLocale } from "next-intl";
import { isRtlLang } from "rtl-detect";
export default function Snackbar(param) {
    let { children } = param;
    // hooks
    const locale = useLocale();
    // constants
    const rtl = isRtlLang(locale);
    return /*#__PURE__*/ _jsx(SnackbarProvider, {
        maxSnack: 3,
        hideIconVariant: false,
        preventDuplicate: true,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: rtl ? 'right' : 'left'
        },
        children: children
    });
}
